export enum FormFieldStateEnum {
    None = 'none',
    HasError = 'has-error',
    HasSuccess = 'has-success',
    IsPending = 'is-pending',
}
